export default [
  {title: "Afghanistan", value: "af"},
  {title: "Åland Islands", value: "ax"},
  {title: "Albania", value: "al"},
  {title: "Algeria", value: "dz"},
  {title: "American Samoa", value: "as"},
  {title: "Andorra", value: "ad"},
  {title: "Angola", value: "ao"},
  {title: "Anguilla", value: "ai"},
  {title: "Antarctica", value: "aq"},
  {title: "Antigua and Barbuda", value: "ag"},
  {title: "Argentina", value: "ar"},
  {title: "Armenia", value: "am"},
  {title: "Aruba", value: "aw"},
  {title: "Australia", value: "au"},
  {title: "Austria", value: "at"},
  {title: "Bahamas", value: "bs"},
  {title: "Bahrain", value: "bh"},
  {title: "Bangladesh", value: "bd"},
  {title: "Barbados", value: "bb"},
  {title: "Belarus", value: "by"},
  {title: "Belgium", value: "be"},
  {title: "Belize", value: "bz"},
  {title: "Benin", value: "bj"},
  {title: "Bermuda", value: "bm"},
  {title: "Bhutan", value: "bt"},
  {title: "Bolivia", value: "bo"},
  {title: "Bosnia and Herzegovina", value: "ba"},
  {title: "Botswana", value: "bw"},
  {title: "Bouvet Island", value: "bv"},
  {title: "Brazil", value: "br"},
  {title: "British Indian Ocean Territory", value: "io"},
  {title: "Brunei Darussalam", value: "bn"},
  {title: "Bulgaria", value: "bg"},
  {title: "Burkina Faso", value: "bf"},
  {title: "Burundi", value: "bi"},
  {title: "Cambodia", value: "kh"},
  {title: "Cameroon", value: "cm"},
  {title: "Canada", value: "ca"},
  {title: "Cape Verde", value: "cv"},
  {title: "Cayman Islands", value: "ky"},
  {title: "Central African Republic", value: "cf"},
  {title: "Chad", value: "td"},
  {title: "Chile", value: "cl"},
  {title: "China", value: "cn"},
  {title: "Christmas Island", value: "cx"},
  {title: "Cocos (Keeling) Islands", value: "cc"},
  {title: "Colombia", value: "co"},
  {title: "Comoros", value: "km"},
  {title: "Congo", value: "cg"},
  {title: "Cook Islands", value: "ck"},
  {title: "Costa Rica", value: "cr"},
  {title: "Cote D'Ivoire", value: "ci"},
  {title: "Croatia", value: "hr"},
  {title: "Cuba", value: "cu"},
  {title: "Cyprus", value: "cy"},
  {title: "Czech Republic", value: "cz"},
  {title: "Denmark", value: "dk"},
  {title: "Djibouti", value: "dj"},
  {title: "Dominica", value: "dm"},
  {title: "Dominican Republic", value: "do"},
  {title: "Ecuador", value: "ec"},
  {title: "Egypt", value: "eg"},
  {title: "El Salvador", value: "sv"},
  {title: "Equatorial Guinea", value: "gq"},
  {title: "Eritrea", value: "er"},
  {title: "Estonia", value: "ee"},
  {title: "Ethiopia", value: "et"},
  {title: "Falkland Islands (Malvinas)", value: "fk",},
  {title: "Faroe Islands", value: "fo"},
  {title: "Fiji", value: "fj"},
  {title: "Finland", value: "fi"},
  {title: "France", value: "fr"},
  {title: "French Guiana", value: "gf"},
  {title: "French Polynesia", value: "pf"},
  {title: "French Southern Territories", value: "tf",},
  {title: "Gabon", value: "ga"},
  {title: "Gambia", value: "gm"},
  {title: "Georgia", value: "ge"},
  {title: "Germany", value: "de"},
  {title: "Ghana", value: "gh"},
  {title: "Gibraltar", value: "gi"},
  {title: "Greece", value: "gr"},
  {title: "Greenland", value: "gl"},
  {title: "Grenada", value: "gd"},
  {title: "Guadeloupe", value: "gp"},
  {title: "Guam", value: "gu"},
  {title: "Guatemala", value: "gt"},
  {title: "Guernsey", value: "gg"},
  {title: "Guinea", value: "gn"},
  {title: "Guinea-Bissau", value: "gw"},
  {title: "Guyana", value: "gy"},
  {title: "Haiti", value: "ht"},
  {title: "Heard Island", value: "hm"},
  {title: "Vatican City State", value: "va"},
  {title: "Honduras", value: "hn"},
  {title: "Hong Kong", value: "hk"},
  {title: "Hungary", value: "hu"},
  {title: "Iceland", value: "is"},
  {title: "India", value: "in"},
  {title: "Indonesia", value: "id"},
  {title: "Iran, Islamic Republic Of", value: "ir"},
  {title: "Iraq", value: "iq"},
  {title: "Ireland", value: "ie"},
  {title: "Isle of Man", value: "im"},
  {title: "Israel", value: "il"},
  {title: "Italy", value: "it"},
  {title: "Jamaica", value: "jm"},
  {title: "Japan", value: "jp"},
  {title: "Jersey", value: "je"},
  {title: "Jordan", value: "jo"},
  {title: "Kazakhstan", value: "kz"},
  {title: "Kenya", value: "ke"},
  {title: "Kiribati", value: "ki"},
  {title: "Korea, Democratic ", value: "kp"},
  {title: "Korea, Republic of", value: "kr"},
  {title: "Kuwait", value: "kw"},
  {title: "Kyrgyzstan", value: "kg"},
  {title: "Lao People'S Democratic Republic", value: "la"},
  {title: "Latvia", value: "lv"},
  {title: "Lebanon", value: "lb"},
  {title: "Lesotho", value: "ls"},
  {title: "Liberia", value: "lr"},
  {title: "Libyan Arab Jamahiriya", value: "ly"},
  {title: "Liechtenstein", value: "li"},
  {title: "Lithuania", value: "lt"},
  {title: "Luxembourg", value: "lu"},
  {title: "Macao", value: "mo"},
  {title: "Macedonia", value: "mk"},
  {title: "Madagascar", value: "mg"},
  {title: "Malawi", value: "mw"},
  {title: "Malaysia", value: "my"},
  {title: "Maldives", value: "mv"},
  {title: "Mali", value: "ml"},
  {title: "Malta", value: "mt"},
  {title: "Marshall Islands", value: "mh"},
  {title: "Martinique", value: "mq"},
  {title: "Mauritania", value: "mr"},
  {title: "Mauritius", value: "mu"},
  {title: "Mayotte", value: "yt"},
  {title: "Mexico", value: "mx"},
  {title: "Micronesia", value: "fm"},
  {title: "Moldova, Republic of", value: "md"},
  {title: "Monaco", value: "mc"},
  {title: "Mongolia", value: "mn"},
  {title: "Montserrat", value: "ms"},
  {title: "Morocco", value: "ma"},
  {title: "Mozambique", value: "mz"},
  {title: "Myanmar", value: "mm"},
  {title: "Namibia", value: "na"},
  {title: "Nauru", value: "nr"},
  {title: "Nepal", value: "np"},
  {title: "Netherlands", value: "nl"},
  {title: "Netherlands Antilles", value: "an"},
  {title: "New Caledonia", value: "nc"},
  {title: "New Zealand", value: "nz"},
  {title: "Nicaragua", value: "ni"},
  {title: "Niger", value: "ne"},
  {title: "Nigeria", value: "ng"},
  {title: "Niue", value: "nu"},
  {title: "Norfolk Island", value: "nf"},
  {title: "Northern Mariana Islands", value: "mp"},
  {title: "Norway", value: "no"},
  {title: "Oman", value: "om"},
  {title: "Pakistan", value: "pk"},
  {title: "Palau", value: "pw"},
  {title: "Panama", value: "pa"},
  {title: "Papua New Guinea", value: "pg"},
  {title: "Paraguay", value: "py"},
  {title: "Peru", value: "pe"},
  {title: "Philippines", value: "ph"},
  {title: "Pitcairn", value: "pn"},
  {title: "Poland", value: "pl"},
  {title: "Portugal", value: "pt"},
  {title: "Puerto Rico", value: "pr"},
  {title: "Qatar", value: "qa"},
  {title: "Reunion", value: "re"},
  {title: "Romania", value: "ro"},
  {title: "Russian Federation", value: "ru"},
  {title: "RWANDA", value: "rw"},
  {title: "Saint Helena", value: "sh"},
  {title: "Saint Kitts and Nevis", value: "kn"},
  {title: "Saint Lucia", value: "lc"},
  {title: "Saint Pierre and Miquelon", value: "pm"},
  {title: "Saint Vincent", value: "vc"},
  {title: "Samoa", value: "ws"},
  {title: "San Marino", value: "sm"},
  {title: "Sao Tome and Principe", value: "st"},
  {title: "Saudi Arabia", value: "sa"},
  {title: "Senegal", value: "sn"},
  {title: "Serbia and Montenegro", value: "cs"},
  {title: "Seychelles", value: "sc"},
  {title: "Sierra Leone", value: "sl"},
  {title: "Singapore", value: "sg"},
  {title: "Slovakia", value: "sk"},
  {title: "Slovenia", value: "si"},
  {title: "Solomon Islands", value: "sb"},
  {title: "Somalia", value: "so"},
  {title: "South Africa", value: "za"},
  {title: "Spain", value: "es"},
  {title: "Sri Lanka", value: "lk"},
  {title: "Sudan", value: "sd"},
  {title: "Surititle", value: "sr"},
  {title: "Svalbard and Jan Mayen", value: "sj"},
  {title: "Swaziland", value: "sz"},
  {title: "Sweden", value: "se"},
  {title: "Switzerland", value: "ch"},
  {title: "Syrian Arab Republic", value: "sy"},
  {title: "Taiwan, Province of China", value: "tw"},
  {title: "Tajikistan", value: "tj"},
  {title: "Tanzania", value: "tz"},
  {title: "Thailand", value: "th"},
  {title: "Timor-Leste", value: "tl"},
  {title: "Togo", value: "tg"},
  {title: "Tokelau", value: "tk"},
  {title: "Tonga", value: "to"},
  {title: "Trinidad and Tobago", value: "tt"},
  {title: "Tunisia", value: "tn"},
  {title: "Turkmenistan", value: "tm"},
  {title: "Turks and Caicos Islands", value: "tc"},
  {title: "Tuvalu", value: "tv"},
  {title: "Uganda", value: "ug"},
  {title: "Ukraine", value: "ua"},
  {title: "United Arab Emirates", value: "ae"},
  {title: "United Kingdom", value: "gb"},
  {title: "United States", value: "us"},
  {title: "Uruguay", value: "uy"},
  {title: "Uzbekistan", value: "uz"},
  {title: "Vanuatu", value: "vu"},
  {title: "Venezuela", value: "ve"},
  {title: "Viet Nam", value: "vn"},
  {title: "Virgin Islands, British", value: "vg"},
  {title: "Virgin Islands, U.S.", value: "vi"},
  {title: "Western Sahara", value: "eh"},
  {title: "Yemen", value: "ye"},
  {title: "Zambia", value: "zm"},
  {title: "Zimbabwe", value: "zw"},
]



// WEBPACK FOOTER //
// ./src/utils/Countries.js